import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-add-conversation-modal',
  templateUrl: './page-add-conversation-modal.component.html',
  styleUrls: ['./page-add-conversation-modal.component.scss']
})
export class PageAddConversationModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
